import {CompanyReportScreen} from "./ProductsReports.jsx";
export default function SalesBasedReports(){return <CompanyReportScreen kind="sales"/>;}
